import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const StarredBoardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StarredBoards"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}},{"kind":"Argument","name":{"kind":"Name","value":"waitOn"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"MemberBoards"}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"boardStars"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idBoard"}},{"kind":"Field","name":{"kind":"Name","value":"pos"}}]}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"StarredBoards","document":StarredBoardsDocument}} as const;
export type StarredBoardsQueryVariables = Types.Exact<{
  memberId: Types.Scalars['ID'];
}>;


export type StarredBoardsQuery = (
  { __typename: 'Query' }
  & { member?: Types.Maybe<(
    { __typename: 'Member' }
    & { boardStars: Array<(
      { __typename: 'BoardStar' }
      & Pick<Types.BoardStar, 'id' | 'idBoard' | 'pos'>
    )> }
  )> }
);




/**
 * __useStarredBoardsQuery__
 *
 * To run a query within a React component, call `useStarredBoardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStarredBoardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStarredBoardsQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useStarredBoardsQuery(baseOptions: Apollo.QueryHookOptions<StarredBoardsQuery, StarredBoardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StarredBoardsQuery, StarredBoardsQueryVariables>(StarredBoardsDocument, options);
      }
export function useStarredBoardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StarredBoardsQuery, StarredBoardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StarredBoardsQuery, StarredBoardsQueryVariables>(StarredBoardsDocument, options);
        }
export type StarredBoardsQueryHookResult = ReturnType<typeof useStarredBoardsQuery>;
export type StarredBoardsLazyQueryHookResult = ReturnType<typeof useStarredBoardsLazyQuery>;
export type StarredBoardsQueryResult = Apollo.QueryResult<StarredBoardsQuery, StarredBoardsQueryVariables>;